"use strict";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(source, true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(source).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireWildcard(require("react"));

var _reactSelect = _interopRequireDefault(require("react-select"));

var _constants = require("@widget-editor/map/lib/constants");

var _flex = _interopRequireDefault(require("../../styles-common/flex"));

var _formLabel = _interopRequireDefault(require("../../styles-common/form-label"));

var _inputGroup = _interopRequireDefault(require("../../styles-common/input-group"));

var _input = _interopRequireDefault(require("../../styles-common/input"));

var _basemaps = _interopRequireDefault(require("./basemaps"));

var _labels = _interopRequireDefault(require("./labels"));

var _boundries = _interopRequireDefault(require("./boundries"));

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}

function _getRequireWildcardCache() {
  if (typeof WeakMap !== "function") return null;
  var cache = new WeakMap();

  _getRequireWildcardCache = function _getRequireWildcardCache() {
    return cache;
  };

  return cache;
}

function _interopRequireWildcard(obj) {
  if (obj && obj.__esModule) {
    return obj;
  }

  if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") {
    return {
      "default": obj
    };
  }

  var cache = _getRequireWildcardCache();

  if (cache && cache.has(obj)) {
    return cache.get(obj);
  }

  var newObj = {};
  var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;

  for (var key in obj) {
    if (Object.prototype.hasOwnProperty.call(obj, key)) {
      var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;

      if (desc && (desc.get || desc.set)) {
        Object.defineProperty(newObj, key, desc);
      } else {
        newObj[key] = obj[key];
      }
    }
  }

  newObj["default"] = obj;

  if (cache) {
    cache.set(obj, newObj);
  }

  return newObj;
}

var InputStyles = {
  control: function control() {
    return {
      display: "flex",
      border: "1px solid rgba(202,204,208,0.85)",
      borderRadius: "4px",
      background: "#FFF",
      padding: "3px 0"
    };
  },
  option: function option(base) {
    return _objectSpread({}, base);
  }
};

var generateOptions = function generateOptions(layers) {
  if (!layers) {
    return [];
  }

  return layers.map(function (l) {
    return {
      label: l.attributes.name,
      value: l.id
    };
  });
};

var MapInfo = function MapInfo(_ref) {
  var editor = _ref.editor,
      configuration = _ref.configuration,
      patchConfiguration = _ref.patchConfiguration,
      editorSyncMap = _ref.editorSyncMap;
  var _editor$layers = editor.layers,
      layers = _editor$layers === void 0 ? null : _editor$layers;
  var options = generateOptions(layers);
  var selectedOption = options.find(function (o) {
    return o.value === configuration.layer;
  });
  (0, _react.useEffect)(function () {
    if (!selectedOption && options.length > 0) {
      patchConfiguration({
        layer: options[0].value
      });
    }
  }, [selectedOption, options, patchConfiguration]);

  var handleChange = function handleChange(option) {
    patchConfiguration({
      layer: option.value
    });
  };

  var setBasemap = function setBasemap(basemap) {
    var patch = _objectSpread({}, configuration.map, {
      basemap: _objectSpread({}, configuration.map.basemap, {
        basemap: basemap
      })
    });

    editorSyncMap(patch);
    patchConfiguration({
      map: patch
    });
  };

  var setLabels = function setLabels(label) {
    var patch = _objectSpread({}, configuration.map, {
      basemap: _objectSpread({}, configuration.map.basemap, {
        labels: label
      })
    });

    editorSyncMap(patch);
    patchConfiguration({
      map: patch
    });
  };

  var setBoundaries = function setBoundaries(active) {
    var patch = _objectSpread({}, configuration.map, {
      basemap: _objectSpread({}, configuration.map.basemap, {
        boundaries: active
      })
    });

    editorSyncMap(patch);
    patchConfiguration({
      map: patch
    });
  };

  return _react["default"].createElement(_flex["default"], null, _react["default"].createElement(_inputGroup["default"], null, _react["default"].createElement(_formLabel["default"], {
    htmlFor: "options-title"
  }, "Layers"), _react["default"].createElement(_reactSelect["default"], {
    onChange: function onChange(option) {
      return handleChange(option);
    },
    value: selectedOption,
    options: options,
    styles: InputStyles
  })), _react["default"].createElement(_inputGroup["default"], null, _react["default"].createElement(_formLabel["default"], {
    htmlFor: "options-basemap"
  }, "Basemap"), _react["default"].createElement(_basemaps["default"], {
    configuration: configuration,
    basemaps: _constants.BASEMAPS,
    onSetBasemap: function onSetBasemap(basemap) {
      return setBasemap(basemap);
    }
  })), _react["default"].createElement(_inputGroup["default"], null, _react["default"].createElement(_formLabel["default"], {
    htmlFor: "options-labels"
  }, "Labels"), _react["default"].createElement(_labels["default"], {
    configuration: configuration,
    labels: _constants.LABELS,
    onSetLabel: function onSetLabel(label) {
      return setLabels(label);
    }
  })), _react["default"].createElement(_inputGroup["default"], null, _react["default"].createElement(_formLabel["default"], {
    htmlFor: "options-boundries"
  }, "Boundaries"), _react["default"].createElement(_boundries["default"], {
    configuration: configuration,
    boundaries: _constants.BOUNDARIES,
    onSetBoundry: function onSetBoundry(active) {
      return setBoundaries(active);
    }
  })));
};

var _default = MapInfo;
exports["default"] = _default;